<template>
  <el-form ref="editedUser" :model="editedUser" label-position="top">
    <el-form-item label="头像">
      <el-upload
        class="avatar-uploader"
        :action="actionUrl"
        :show-file-list="false"
        :headers="{ Authorization: 'Bearer ' + token }"
        :data="{ type: 'avatar' }"
        name="image"
        :on-success="handleAvatarSuccess"
        :before-upload="beforeAvatarUpload"
      >
        <img
          loading="lazy"
          :title="'用户' + editedUser.name"
          :alt="editedUser.name"
          v-if="editedUser.avatar"
          :src="editedUser.avatar"
          class="avatar"
          style="height:unset"
        />
        <i v-else class="el-icon-plus avatar-uploader-icon"></i>
      </el-upload>
    </el-form-item>
    <el-form-item>
      <template v-slot:label>
        <el-tooltip
          slot="reference"
          class="item"
          effect="dark"
          :content="
            user.email != null ? '邮箱不能被修改' : '只能被修改一次邮箱'
          "
          placement="left"
        >
          <span>
            邮箱
            <font-awesome-icon icon="question-circle" />
          </span>
        </el-tooltip>
      </template>
      <el-input
        :disabled="user.email != null"
        v-model="editedUser.email"
      ></el-input>
      <p v-if="user.email == null" style="color:red">
        邮箱有且只能被设置一次，回复通知信息将会发送到该邮箱。
        也可以稍后修改，但添加邮箱之前，您将收不到任何回复邮件
      </p>
      <el-form-item>
        <el-checkbox v-model="editedUser.public_email"
          >邮箱公开显示
        </el-checkbox>
        &nbsp;
        <el-tooltip
          class="item"
          effect="dark"
          content="开启后其他用户可以看到你的邮箱"
          placement="left"
        >
          <font-awesome-icon icon="question-circle" />
        </el-tooltip>
      </el-form-item>
    </el-form-item>

    <el-form-item>
      <template v-slot:label>
        <el-tooltip
          slot="reference"
          class="item"
          effect="dark"
          content="用户名必须介于 3 - 25 个字符之间，用户名只支持中英文、数字、横杆和下划线。"
          placement="left"
        >
          <span>
            用户名
            <font-awesome-icon icon="question-circle" />
          </span>
        </el-tooltip>
      </template>
      <el-input v-model="editedUser.name"></el-input>
    </el-form-item>
    <el-form-item>
      <template v-slot:label>
        <el-tooltip
          slot="reference"
          class="item"
          effect="dark"
          content="签名必须小于140个字符"
          placement="left"
        >
          <span>
            签名
            <font-awesome-icon icon="question-circle" />
          </span>
        </el-tooltip>
      </template>
      <el-input v-model="editedUser.introduction"></el-input>
    </el-form-item>
    <el-form-item>
      <el-button @click="update" class="float-right">修改</el-button>
    </el-form-item>
  </el-form>
</template>

<script>
import { mapState, mapMutations, mapActions } from "vuex";

export default {
  data() {
    return {
      editedUser: {
        avatar: "",
        email: "",
        id: "",
        introduction: "",
        name: "",
        public_email: ""
      }
    };
  },
  computed: {
    ...mapState(["user", "token"]),
    actionUrl: function() {
      return process.env.VUE_APP_API_BASE_URL + "/images/";
    }
  },
  methods: {
    ...mapMutations(["setLoading"]),
    ...mapActions(["updateUserInfo"]),
    update: function() {
      this.setLoading(true);
      var self = this;
      this.updateUserInfo(this.editedUser)
        .then(() => {
          this.$message({
            message: "用户设置已更新",
            type: "success",
            duration: 5000
          });
          self.setLoading(false);
        })
        .catch(err => {
          if (err.response.status != 422) {
            this.$message({
              message: ":( 更新未成功，请稍后重试",
              type: "error",
              duration: 3000
            });
          }
          self.setLoading(false);
        });
    },
    syncWithLoggedInUser: function(loggedInUser) {
      this.$emit("syncUser");
      this.editedUser.avatar = loggedInUser.avatar;
      this.editedUser.email = loggedInUser.email;
      this.editedUser.introduction = loggedInUser.introduction;
      this.editedUser.name = loggedInUser.name;
      this.editedUser.public_email = loggedInUser.public_email;
    },
    handleAvatarSuccess(res) {
      this.editedUser.avatar = res.path;
    },
    beforeAvatarUpload(file) {
      var mimes = ["image/png", "image/jpeg", "image/gif", "image/jpg"];
      const isValid = mimes.includes(file.type);
      const isLt50M = file.size / 1024 / 1024 < 50;

      if (!isValid) {
        this.$message({
          showClose: true,
          type: "error",
          message: "头像必须是以下类型的图片 JPG, JPEG或者PNG!"
        });
      }
      if (!isLt50M) {
        this.$message({
          showClose: true,
          type: "error",
          message: "头像图片最大不超过50MB!"
        });
      }
      return isValid && isLt50M;
    }
  },
  created: function() {
    this.syncWithLoggedInUser(this.user);
  },
  watch: {
    user(newValue) {
      this.syncWithLoggedInUser(newValue);
    },
    "user.avatar": function(newVal, oldVal) {
      if (oldVal != undefined) {
        this.$http({
          url: "/images",
          method: "DELETE",
          data: { image: oldVal }
        });
      }
    }
  }
};
</script>

<style>
.avatar-uploader .el-upload {
  border: 1px dashed #d9d9d9;
  border-radius: 6px;
  cursor: pointer;
  position: relative;
  overflow: hidden;
  margin: 0 auto;
}
.avatar-uploader .el-upload:hover {
  border-color: #409eff;
}
.avatar-uploader-icon {
  font-size: 28px;
  color: #8c939d;
  width: 99px;
  height: 99px;
  line-height: 99px;
  text-align: center;
}
.avatar {
  width: 99px;
  height: 99px;
  display: block;
}
</style>
